import { Service, ServiceImpl } from "./service";
import { AuthControl } from "../authControl"

export const FEEDBACK_EVENT_TYPE = "feedback";
export const ACTION_PRESENTED_EVENT_TYPE = "actionPresented";
export const ACTION_TAKEN_EVENT_TYPE = "actionTaken";

export type ActionEventParams = {
  actionId: string,
  roadtripId?: string,
  stopId?: string
}
export interface EventsService extends Service {
  feedbackEvent(
    featureId: string,
    roadtripId?: string,
    binaryFeedback?: boolean,
    reason?: string,
    otherText?: string): Promise<void>;

  actionPresentedEvent(params: ActionEventParams): Promise<void>;

  actionTakenEvent(params: ActionEventParams): Promise<void>;
}

export class EventsServiceImpl extends ServiceImpl implements EventsService {
  constructor(
    apiServer: string,
    authControl: AuthControl
  ) {
    super(apiServer, authControl)
  };

  async feedbackEvent(
    featureId: string, 
    roadtripId?: string,
    binaryFeedback?: boolean,
    reason?: string,
    otherText?: string
    ): Promise<void> {
    return await this.post(`/v1/events`, {
      eventType: FEEDBACK_EVENT_TYPE, 
      roadtripId,
      featureId,
      binaryFeedback,
      reason,
      otherText
    });
  }

  async actionPresentedEvent(params: ActionEventParams): Promise<void> {
    return await this.post(`/v1/events`, {
      eventType: ACTION_PRESENTED_EVENT_TYPE, 
      ...params
    });
  }

  async actionTakenEvent(params: ActionEventParams): Promise<void> {
    return await this.post(`/v1/events`, {
      eventType: ACTION_TAKEN_EVENT_TYPE,
      ...params
    });
  }


}
